import { Collapsible } from "@base-ui-components/react/collapsible";
import { Section } from "../components/Section";
import { CLOUDFLARE_ROLES, type LinkedInRole } from "../lib/work";

// Work history = Cloudflare only, in AJ's LinkedIn wording (lib/work.tsx). The
// resume at /resume keeps its own copy (lib/resume.tsx).
export function Work() {
  return (
    <Section id="work" label="work history" title="work history">
      <div className="panel relative mt-8 p-6" style={{ borderTopColor: "var(--orange)", borderTopWidth: 4 }}>
        <span className="etch-label absolute -top-3 left-5 bg-bg px-2.5 !text-[13px] !text-amber">
          Cloudflare
        </span>
        {CLOUDFLARE_ROLES.map((r, i) =>
          i === 0 ? (
            <div key={r.dates}>
              <RoleHeader role={r} />
              <Bullets bullets={r.bullets} />
            </div>
          ) : (
            // Earlier roles collapse to their header to save space (Base UI Collapsible,
            // same pattern as the Letterboxd review cards).
            <Collapsible.Root key={r.dates} className="mt-6 border-t border-dashed border-line-2 pt-5">
              <Collapsible.Trigger className="group flex w-full items-start gap-3 bg-transparent text-left">
                <div className="min-w-0 flex-1">
                  <RoleHeader role={r} />
                </div>
                <span className="mt-1 flex-none text-amber transition-transform group-data-[panel-open]:rotate-90">
                  ▸
                </span>
              </Collapsible.Trigger>
              <Collapsible.Panel className="collapse-panel">
                <Bullets bullets={r.bullets} />
              </Collapsible.Panel>
            </Collapsible.Root>
          ),
        )}
      </div>
    </Section>
  );
}

function RoleHeader({ role }: { role: LinkedInRole }) {
  return (
    <>
      <h3 className="font-display text-[15px] font-semibold uppercase tracking-wide md:text-lg">
        {role.title}
      </h3>
      <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="vfd-box !text-[13px]">{role.dates}</span>
        <span className="etch-label !text-[12px] !text-text-mute">
          {role.duration} · {role.place}
        </span>
      </div>
    </>
  );
}

function Bullets({ bullets }: { bullets: LinkedInRole["bullets"] }) {
  return (
    <ul className="mt-4 space-y-2 text-[15px] text-text-dim">
      {bullets.map((b, j) => (
        <li key={j} className="relative pl-5">
          <span className="absolute left-0 text-orange" aria-hidden="true">
            ▸
          </span>
          {b}
        </li>
      ))}
    </ul>
  );
}
